// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueChatScroll from 'vue-chat-scroll'

Vue.config.productionTip = false
Vue.use(VueChatScroll)

import jQuery from 'jquery'
Object.defineProperty(Vue.prototype, '$j', { value: jQuery })

import {ApiAiClient} from 'api-ai-javascript/es6/ApiAiClient'
const apiAi = new ApiAiClient({
  // accessToken: 'c1c262ef521b4da7b44bd66b3cbb6ad1', // ?
  accessToken: '65f89ad0a0114b5988c2348b852e15e5', // mb-speech-en
  streamClientClass: 'ApiAiStreamClient'
})
Object.defineProperty(Vue.prototype, '$apiAi', { value: apiAi })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js